import imageMobile from '../../../../assets/images/mobile_rentings.png';
import React, { useEffect, useState } from 'react';
import {
    BoxedRow,
    Circle,
    IconChevronLeftRegular,
    IconTechServiceRegular,
    NavigationBar,
    skinVars,
    Text1,
    Text2,
    ThemeVariant,
} from '@telefonica/mistica';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getCatalogImage } from '../../../../services/ProductService';
import { retrieveDevices, saveDevice } from '../devicesStorage';
import { Device } from '../../../../models/Devices';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { id } from 'date-fns/locale';
import navigateParams from '../../../../utils/navigation/navigateParams';
import Stopper from '../../../../components/Stopper';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';

const Devices: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [devices, setDevices] = useState<Device[]>([]);
    const [images, setImages] = useState<string[]>([]);
    const { trackingScreenView } = new TrackingEvents();

    const promises: Promise<string>[] = [];
    const homeDisabled = managementEnvironment().REACT_APP_STOPPER_HOME_DISABLED;

    useEffect(() => {
        const { devices } = retrieveDevices();
        setDevices(devices);
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        devices.forEach((item) =>
            promises.push(
                getCatalogImage(item.imageId)
                    .then((response) => `data:image/jpg;base64,${response.data.content}`)
                    .catch(() => imageMobile),
            ),
        );
        Promise.all(promises).then((images) => setImages(images));
    }, []);

    const sendToNative = (url: string, type: string, title: string, productId?: string) => {
        if (url === '/device-detail') {
            const device = devices.find((item: Device) => item.productId === productId)!;
            const storage = {
                device: device,
            };
            saveDevice(device);
            if (navigateParams(type, url, {}, storage, title, id)) {
                navigate(url);
            }
        } else {
            if (navigateParams(type, url, {}, {}, title)) {
                if (url === 'https://o2online.es/reparacion/') {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
            }
        }
    };

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <>
            <div className='devices-header' style={{ background: skinVars.colors.navigationBarBackground }}>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='devices-header-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('devices')}
                            />
                        </div>
                        <div className='devices-header-return'>
                            <div
                                className='devices-header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='devices-header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='devices-header-breadcrumbs' style={{ background: skinVars.colors.backgroundBrand }}>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('devicesSection')}
                            breadcrumbs={[{ title: t('breadcrumbsHome'), url: '/home' }]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='devices-content'>
                {devices?.length > 0 && (
                    <>
                        <div className='devices-content__title'>
                            <Text1 medium color={skinVars.colors.neutralMedium}>
                                {t('contentTitleDevicesList')}
                            </Text1>
                        </div>
                        <div className='devices-content__info'>
                            <div className='devices-content__info__rows'>
                                {devices.map((item, index) => (
                                    <div className='devices-content__info__rows__list' key={index}>
                                        <BoxedRow
                                            asset={<img src={images[index]} height='100' />}
                                            title={item.name}
                                            description={item.endDate ? t('includeDevice') : t('freeDevice')}
                                            onPress={() => {
                                                sendToNative(
                                                    '/device-detail',
                                                    'modeFlow-backgroundBlue',
                                                    t('devices'),
                                                    `${item.productId}`,
                                                );
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className='devices-content__info__repair'>
                                <div className='devices-content__info__repair-row'>
                                    <BoxedRow
                                        title={t('devicesBoxedRowTitle')}
                                        asset={
                                            <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                                <IconTechServiceRegular color={skinVars.colors.brand} />
                                            </Circle>
                                        }
                                        description={t('devicesBoxedRowSubtitle')}
                                        onPress={() => {
                                            sendToNative(
                                                'https://o2online.es/reparacion/',
                                                'modeExternal',
                                                'Reparación de dispositivos',
                                            );
                                        }}
                                    ></BoxedRow>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Devices;
